import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import screenfull from 'screenfull';

import { SettingsService } from '../../../core/settings/settings.service';

import { MenuService } from '../../../core/menu/menu.service';
import { UserService } from '../../../resources/auth/user.service';
import { User } from '../../../resources/models/user.model';
import { AuthenticationService } from '../../../resources/auth/authentication.service';
import { Router } from '@angular/router';
import { MenuItem } from '../../../models/menu-item';

const browser = require('jquery.browser');
const $ = require('jquery');
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  user: User;

  navCollapsed: boolean = true; // for horizontal layout
  menuItems: MenuItem[] = []; // for horizontal layout

  isNavSearchVisible: boolean;
  @ViewChild('fsbutton') fsbutton: ElementRef;  // the fullscreen button

  constructor(
    public menu: MenuService,
    public settings: SettingsService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.isNavSearchVisible = false;
    if (browser.msie) { // Not supported under IE
      this.fsbutton.nativeElement.style.display = 'none';
    }

    this.userService.user.subscribe((user: User) => {
      this.user = user;
    });

  }

  openNavSearch(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setNavSearchVisible(stat: boolean) {
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  toggleCollapsedSideabar() {
    this.settings.layout.isCollapsed = !this.settings.layout.isCollapsed;
  }

  isCollapsedText() {
    return this.settings.layout.isCollapsedText;
  }

  toggleFullScreen() {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
    // Switch icon indicator
    let el = $(this.fsbutton.nativeElement);
    if (screenfull.isFullscreen) {
      el.children('em').removeClass('fa-expand').addClass('fa-compress');
    } else {
      el.children('em').removeClass('fa-compress').addClass('fa-expand');
    }
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/dashboard/header/header.component.ts